import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios, { AxiosRequestConfig } from "axios";
import "react-phone-input-2/lib/style.css";
import FormHeader from "../../../Common/components/templates/formHeader";
import FormDirections from "../../../Common/components/templates/formDirections";
import "../../styles/EmailSent.css";
import { Button } from "@mui/material";
import { globalConfig } from "../../../Common/configuration/config";
import { FormattedMessage, useIntl } from "react-intl";
import { getLocale } from "../../../Common/localization/localizationHelper";
import SecondaryButton from "../../../Common/components/templates/buttons/secondary";

const EmailSent = (props: any) => {
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
    const email = user?.email;
    const [loading, setLoading] = useState(false);
    const config = globalConfig.get();

    const sendEmail = async () => {
        if (email) {
            try {
                setLoading(true);

                const options = await getAxiosOptions();

                await axios.post(
                    `${config.ApiUrl}/api/v1/profile/start-mfa-reset`,
                    {},
                    options
                );
            } catch (error) {
                console.error('Error sending email:', error);
            } finally {
                setLoading(false);

            }
        }
    };

    const getAxiosOptions = async () : Promise<AxiosRequestConfig> => {
        const token = await getAccessTokenSilently();
        const options: AxiosRequestConfig = {
            headers: {
                Authorization: `Bearer ${token}`,
                'accept': 'text/plain'
            }
        }
        const locale = getLocale();
        if (locale) {
            options.params = {
                ui_locales: locale
            }
        }
        return options;
    }

    useEffect(() => {
        if (isAuthenticated) {
            sendEmail();
        }
    }, [getAccessTokenSilently, email, isAuthenticated]);

    return (
        <form className="form">
            <FormHeader title={useIntl().messages["mfa.emailsent.header"]}/>
            <div className="content">
                <FormDirections>
                        <FormattedMessage id="mfa.emailsent.description"></FormattedMessage>
                </FormDirections>
                <div className="email-sent-verify directions">                 
                    <FormattedMessage id="mfa.emailsent.verify"></FormattedMessage>
                </div>
                <SecondaryButton
                    variant="outlined"
                    color="primary"
                    onClick={sendEmail}
                    disabled={loading}
                    className="resend-button"
                >
                    <FormattedMessage id="mfa.emailsent.button.resend"></FormattedMessage>

                </SecondaryButton>
            </div>
        </form>
    );
};

export default EmailSent;
